'use strict';

require('../modules/props/channel.js');
require('../modules/props/company.js');
